module.exports = __webpack_public_path__ + "media/belt_center_talk.99cb33cb.mp3";